// extracted by mini-css-extract-plugin
export default {"tupacGrid":"pp-z","tupacHeader":"qp-z","tupacHeader2":"rp-z","tupacMenu":"sp-z","tupacMenu2":"tp-z","tupacMain":"up-z","tupacMain2":"vp-z"};